import { CreateEditorMode } from '../EditorModeInfo';

export const ViewMode = CreateEditorMode(
    'view',
    'View Mode',
    'This is just a mode to view the board, it shouldn\'t appear as a UI item anywhere.',
    'deqo://icons/d2/eye'
);
